<template>
  <div>
    <el-card class="monitor-card">
      <div slot="header" class="header">
        <span>{{ title }}</span>
        <div>
          <slot name="filter"></slot>
        </div>
      </div>
      <div class="content">
        <slot name="content"></slot>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/colors.scss';

.monitor-card {
  border-radius: 0.5rem;

  ::v-deep .el-card__header {
    background: $color-light;
    padding: 0.75rem 1rem;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 700;
  min-height: 2.5rem;
}

.content {
  min-height: 7rem;
}
</style>
